<template>
  <div class="user-list">
    <data-table
      :headers="headers"
      v-model="users"
      :items-per-page="10"
      filterable
      editable-columns
      title="Users"
    >
      <template v-slot:item.actions="{ item }">
        <loading-icon-button
          @click="openUser(item)"
          tooltip="Edit"
          :loading="progress_indicator.load_user_id == item.id"
        >
          edit
        </loading-icon-button>
        <loading-icon-button
          @click="openAPITokens(item)"
          tooltip="API Access"
          :loading="progress_indicator.load_api_tokens_user_id == item.id"
        >
          api
        </loading-icon-button>
      </template>
    </data-table>
  </div>
</template>
<script>
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";
import filters from "@/components/utils/filters";

export default {
  components: {
    LoadingIconButton,
    DataTable,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: null,
      default: () => null,
    },
  },
  data() {
    return {
      headers: [
        {
          text: 'ID',
          value: 'id',
          sort: true,
          classFunction(item){
            if(item.roles.includes('super-admin')) return 'red_role';
            return [];
          },
          width: '105px',
          search: true,
        },
        {
          text: "Name",
          value: "user_name",
          valueFunction(item) {
            return filters.name(item)
          },
          sort: false,
          search: true,
        },
        {
          text: "Email",
          value: "email",
          sort: true,
          search: true,
        },
        {
          text: "Seating",
          value: "seating",
          sort: true,
          search: true,
        },
        {
          text: "Primary Pod",
          value: "user_pod",
          sort: true,
          search: true,
        },
        {
          text: "Other Pod(s)",
          value: "secondary_pods",
          valueFunction(item){
            return filters.list(item.secondary_pods)
          },
          sort: false,
          search: true
        },
        {
          text: "Role",
          value: "roles",
          valueFunction(item){
            return filters.list(item.roles)
          },
          sort: true,
          search: true,
        },
        {
          text: "API Tokens",
          value: "api_tokens",
          sort: false,
          width: '100px',
          search: false,
        },
        {
          text: "Actions",
          value: "actions",
          align: "right",
          width: '130px',
          optional: false,
        },
      ],
      progress_indicator:{
        load_user_id: false,
        load_api_tokens_user_id: false,
      }
    }
  },
  methods: {
    openUser(user){
      this.$emit("open-user", user);
    },
    openAPITokens(user) {
      this.$emit("open-api-token", user);
    },
    ...filters,
  },
  computed: {
    users() {
      return this.items ?? [];
    },
  },
  filters: {
    ...filters,
  },
  created() {

  },
}
</script>
<style scoped lang="scss">
::v-deep .red_role{
  border-left: solid 5px #d9808c;
}
</style>
